// Public onboarding profile page (Phase 1e) — reached from /onboarding/:token,
// no login. The new hire sees their start date, progress and checklist.
import { useState, useEffect } from 'react';
import { api } from './api';

const C = { primary: '#DC0069', text: '#111927', sub: '#6C737F', border: '#E5E7EB', bg: '#F9FAFB', green: '#0B815A', n100: '#F3F4F6' };

export default function PublicOnboarding() {
  const token = decodeURIComponent(window.location.pathname.replace(/^\/onboarding\//, ''));
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { api.publicOnboarding(token).then(setD).catch((e) => setErr(e.message)); }, [token]);

  const wrap = { minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', fontFamily: 'Inter, system-ui, sans-serif', padding: 20 };
  const card = { width: '100%', maxWidth: 520, background: '#fff', border: `1px solid ${C.border}`, borderRadius: 20, padding: 32, marginTop: 40, boxShadow: '0 20px 50px rgba(16,24,40,0.08)' };
  if (err && !d) return <div style={wrap}><div style={{ ...card, color: '#B42318', textAlign: 'center' }}>{err}</div></div>;
  if (!d) return <div style={wrap}><div style={card}>Loading…</div></div>;

  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.primary, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{d.company}</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: C.text, margin: '8px 0 2px' }}>Welcome, {d.candidateName} 👋</h1>
        <p style={{ color: C.sub, fontSize: 14 }}>{d.role} · starting {d.start}</p>

        <div style={{ margin: '20px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
            <span style={{ color: C.sub }}>Onboarding progress</span>
            <span style={{ fontWeight: 700, color: C.text }}>{d.progress}%</span>
          </div>
          <div style={{ height: 8, background: C.n100, borderRadius: 6, overflow: 'hidden' }}>
            <div style={{ width: `${d.progress}%`, height: '100%', background: C.primary, borderRadius: 6 }} />
          </div>
        </div>

        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: C.sub, marginBottom: 8 }}>Your onboarding checklist</div>
        <div style={{ display: 'grid', gap: 8 }}>
          {d.tasks.map((t, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', border: `1px solid ${C.border}`, borderRadius: 10, opacity: t.done ? 0.65 : 1 }}>
              <span style={{ width: 18, height: 18, borderRadius: 99, background: t.done ? C.green : '#fff', border: `2px solid ${t.done ? C.green : C.border}`, color: '#fff', fontSize: 11, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{t.done ? '✓' : ''}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13.5, color: C.text, fontWeight: 500, textDecoration: t.done ? 'line-through' : 'none' }}>{t.text}</div>
                {(t.owner || t.dueDate) && <div style={{ fontSize: 12, color: C.sub }}>{t.owner || ''}{t.owner && t.dueDate ? ' · ' : ''}{t.dueDate ? `by ${t.dueDate}` : ''}</div>}
              </div>
            </div>
          ))}
        </div>

        <p style={{ fontSize: 12.5, color: C.sub, marginTop: 18, textAlign: 'center' }}>Your HR team is preparing everything for your first day. Questions? Just reply to your welcome email.</p>
      </div>
    </div>
  );
}
